import React from 'react';
import Head from 'next/head';
import Image from 'next/image';
import { Box, Button } from '@mui/material';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { getBlogPage } from '../../../api/page/blog.js';
import { getMenuItems } from '../../../api/menu/menu.js';
import { getFooterItems } from '../../../api/footer/footer';
import { useOnRenderedContext } from '../../../context/OnRenderedContext.js';
import { HeaderWithMenu } from '../../../components/index.js';
import { faWeight } from '@fortawesome/free-solid-svg-icons';
import BlogBreadcrumb from '../../../components/blog/BlogBreadcrumb.js';
import BlogCategory from '../../../components/blog/BlogCategory.js';

const MAX_WIDTH = '1600px';
const path = 'guide/domande-frequenti/';
const slug = 'domande-frequenti';
const slugLabel = 'Domande frequenti';
const ogImage = '';
const metaTitle = 'Domande frequenti su mutui e tassi di interesse';
const metaDescription = `Vuoi chiedere un mutuo in banca per comprare casa ma hai mille dubbi, domande o perplessità? In questa sezione trovi tutte le risposte che cerchi.`;
const categoryDescription = `È perfettamente naturale, prima di chiedere un mutuo in banca, avere tanti dubbi, paure ed incertezze. Quale mutuo conviene, a quale banca rivolgermi, come chiudere in anticipo un mutuo o come trasferirlo in un'altra banca? Queste e tante altre domande sono state raccolte in questa sezione, dedicata alle FAQ sui mutui, ovvero alle tante domande che ci avete posto via mail e che sono comuni a chi sta per realizzare il suo sogno di comprare casa.`;
const mainTitle = 'DOMANDE FREQUENTI';
const gradientStart = 'rgba(55,153,208,1)';
const gradientMiddle = 'rgba(55,153,208,0)';
const gradientEnd = 'rgba(55,153,208,0)';

const Category = props => {
  const { pages, total, menuItems } = props;
  const [, setOnRendered] = useOnRenderedContext();

  const { t } = useTranslation();

  setOnRendered(true, 'blog category');

  const router = useRouter();
  const p = router.asPath.slice(1);
  const canonicalURL = `https://www.tassomutuo.it/${p}`.split('?')[0];

  return (
    <>
      <Head>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <link rel="canonical" href={canonicalURL} />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:image" content={ogImage} />
      </Head>
      <style>{':root { --category-color: #3799D0}; body { overflow-x:unset};'}</style>
      <HeaderWithMenu menuItems={menuItems} />

      <Box
        className="blogCategoryContainer"
        sx={{
          padding: '80px 0px 0px 0px',
        }}>
        <Box
          className="blogCategoryHeading"
          sx={{
            backgroundImage: 'url(/books-finanziamento.svg)',
            backgroundColor: 'var(--category-color)',
            backgroundSize: 'cover',
            position: 'relatve',
            overflow: 'hidden',
          }}>
          <Box
            type="h1"
            display="flex"
            sx={{
              background: 'transparent',
              width: '100%',
              minHeight: '300px',
              color: '#fff',
              justifyContent: 'center',
              alignItems: 'center',
              fontFamily: 'var(--font-red-hat-display)',
              fontWeight: 'bold',
              fontSize: '52px',
              background: `linear-gradient(0deg, ${gradientStart} 0%, ${gradientMiddle} 94%, ${gradientEnd} 100%)`,
              textShadow: '0px 4px 4px rgba(0,0,0,0.2);',
            }}>
            {mainTitle}
          </Box>
        </Box>
        {/* functionality separator */}
        <Box
          className="Blog"
          display="flex"
          sx={{
            maxWidth: MAX_WIDTH,
            margin: '0 auto',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: ' 60px 40px',
            '@media(max-width: 900px)': { padding: '60px 20px' },
          }}>
          <BlogBreadcrumb category={slug} label={slugLabel} />
          {/* <Box>search</Box> */}
        </Box>
        <Box
          type="p"
          sx={{
            maxWidth: MAX_WIDTH,
            margin: '0 auto',
            padding: ' 0px 40px 40px 40px',
            fontSize: '25px',
            '@media(max-width: 900px)': { padding: '0px 20px 40px 20px' },
          }}>
          {categoryDescription}
        </Box>
        <Box
          className="blogCategoryList"
          sx={{
            maxWidth: MAX_WIDTH,
            margin: '0 auto',
            padding: ' 0px 40px 40px 40px',
            '@media(max-width: 900px)': { padding: '0px 20px 40px 20px' },
          }}>
          <BlogCategory pages={pages} />
        </Box>
      </Box>
    </>
  );
};

export async function getServerSideProps({ query }) {
  try {
    const res = await getBlogPage(path, 0, 30);
    const menuItemsRes = await getMenuItems();
    const menuFiiterRes = await getFooterItems();

    const { data: menuItems } = menuItemsRes;
    const { data: footerItems } = menuFiiterRes;

    const {
      data: { pages, total },
    } = res;

    return {
      props: {
        pages,
        total,
        menuItems,
        footerItems,
      },
    };
  } catch (e) {
    return {
      notFound: true,
    };
  }
}

export default Category;
